import { useCallback, useReducer } from 'react'
import effects from 'app/effects/effects'

export const ActionType = {
  START_LOADING: 'START_LOADING',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_ERROR: 'FETCH_ERROR',
  UPDATE_TOPICS: 'UPDATE_TOPICS',
  LOAD_MORE_START: 'LOAD_MORE_START',
  LOAD_MORE_SUCCESS: 'LOAD_MORE_SUCCESS',
  CLEAR_STATE: 'CLEAR_STATE',
  SET_DEFAULT_SELECTED: 'SET_DEFAULT_SELECTED',
}

const initialState = (value) => {
  return {
    topics: [],
    isLoading: false,
    isLoadmore: false,
    error: undefined,
    selected: [],
    meta: {
      currentPage: 1,
      lastPage: undefined,
    },
  }
}
const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.START_LOADING:
      return { ...state, isLoading: true }
    case ActionType.FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        topics: action.payload.data,
        meta: {
          currentPage: action.payload.meta.currentPage,
          lastPage: action.payload.meta.lastPage,
        },
        error: undefined,
      }
    case ActionType.FETCH_ERROR:
      return { ...state, isLoading: false, topics: [], error: action.payload }
    case ActionType.UPDATE_TOPICS:
      return {
        ...state,
        selected: action.payload,
      }
    case ActionType.LOAD_MORE_START:
      return { ...state, isLoadmore: true }
    case ActionType.LOAD_MORE_SUCCESS:
      return {
        ...state,
        isLoadmore: false,
        topics: action.payload.data,
        meta: {
          currentPage: action.payload.meta.currentPage,
          lastPage: action.payload.meta.lastPage,
        },
        error: undefined,
      }

    case ActionType.SET_DEFAULT_SELECTED:
      return {
        ...state,
        selected: action.payload,
      }
    case ActionType.CLEAR_STATE:
      return initialState(action.payload)
    default:
      return state
  }
}

export default function useSelectTopics(value) {
  const [state, dispatch] = useReducer(reducer, initialState(value))

  const onFetchTopics = useCallback(({ page, limit, search, topics }) => {
    const isLoadmore = page > 1
    dispatch({
      type: isLoadmore ? ActionType.LOAD_MORE_START : ActionType.START_LOADING,
    })

    effects.apis
      .getTopicsForSubscriberAttach({
        page,
        limit,
        search,
      })

      .then((response) => {
        dispatch({
          type: isLoadmore
            ? ActionType.LOAD_MORE_SUCCESS
            : ActionType.FETCH_SUCCESS,
          payload: {
            data: isLoadmore ? [...topics, ...response.data] : response.data,
            meta: response.meta,
          },
        })
      })
      .catch((error) => {
        dispatch({ type: ActionType.FETCH_ERROR, payload: error })
      })
  }, [])

  const startProcess = async ({ page, limit, search, topics, value }) => {
    dispatch({ type: ActionType.SET_DEFAULT_SELECTED, payload: value })
    onFetchTopics({ page, limit, search, topics })
  }

  const onSelectTopics = (topicsId) => {
    const isTopicsSelected = state.selected.includes(topicsId)

    const updatedTopics = isTopicsSelected
      ? state.selected.filter((id) => id !== topicsId)
      : [...state.selected, topicsId]

    dispatch({
      type: ActionType.UPDATE_TOPICS,
      payload: updatedTopics,
    })
  }

  const loadMore = ({ page, limit, topics }) => {
    onFetchTopics({
      topics,
      page: page + 1,
      limit,
      search: '',
    })
  }

  const onSearchChange = ({ limit, keyword, topics }) => {
    onFetchTopics({
      topics,
      page: 1,
      limit,
      search: keyword,
    })
  }

  const clearState = () => {
    dispatch({ type: ActionType.CLEAR_STATE, payload: value })
  }

  return {
    state,
    startProcess,
    onFetchTopics,
    onSelectTopics,
    loadMore,
    onSearchChange,
    clearState,
  }
}
